import { Image, List, Stack, Text } from '@mantine/core';
import { FC, memo } from 'react';
import { Theme } from 'src/api/themes/types';

type Props = {
  theme: Theme;
};

export const ThemeDetails: FC<Props> = memo(({ theme }) => (
  <Stack gap="sm">
    <Image
      w={200}
      src={theme.image}
      alt={`Preview of ${theme.name}`}
      radius="md"
    />

    <List spacing="xs" listStyleType="none">
      <List.Item>
        <Text size="xs">
          Name:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {theme?.name}
          </Text>
        </Text>
      </List.Item>

      <List.Item>
        <Text size="xs">
          Theme ID (Unity):{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {theme?.theme_id}
          </Text>
        </Text>
      </List.Item>

      <List.Item>
        <Text size="xs">
          Interaction Dictionary ID:{' '}
          <Text component="span" fw={600} c="var(--color-white)">
            {theme?.interaction_dictionary_id}
          </Text>
        </Text>
      </List.Item>
    </List>
  </Stack>
));

ThemeDetails.displayName = 'ThemeDetails';
